import React from 'react';
import { Card, CheckboxLabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './organizerProfile.scss';

const CheckBoxLabelContainer = ({ formOrganisation, onChange }) => {
    const { t } = useTranslation();

    return (
        <CheckboxLabel
            className="wz-class"
            errors={[]}
            label={t('ticket.organiser.sworn_statement.label')}
            name="checkboxA"
            onChange={(e, { checked }) => onChange('sworn', checked)}
            checked={formOrganisation.sworn}
        />
    );
};
CheckBoxLabelContainer.propTypes = {
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};
export default function SwornStatement({ formOrganisation, onChange }) {
    const { t } = useTranslation();

    return (
        <Card.FormStep className="organizer-formstep-form" title={t(`ticket.organiser.sworn_statement.title`)} rightComponent id="organiser-form-general_information">
            <CheckBoxLabelContainer onChange={onChange} formOrganisation={formOrganisation} />
        </Card.FormStep>
    );
}
SwornStatement.propTypes = {
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};
